import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  campoFormulario: {
    marginTop: theme.spacing(2),
  },
  botoesFormulario: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(3),
    width: '100%',
    alignItems: 'center',
  },
}))

export default useStyles
